export const ADD_ADMIN = 'ADD_ADMIN'
export const ADD_ADMIN_REQUEST = 'ADD_ADMIN_REQUEST'
export const ADD_ADMIN_SUCCESS = 'ADD_ADMIN_SUCCESS'
export const ADD_ADMIN_ERROR = 'ADD_ADMIN_ERROR'

export const RESET_ADMIN_FORM_ACTION = 'RESET_ADMIN_FORM_ACTION'

export const FETCH_ADMINS_REQUEST = 'FETCH_ADMINS_REQUEST'
export const FETCH_ADMINS_SUCCESS = 'FETCH_ADMINS_SUCCESS'
export const FETCH_ADMINS_FAILURE = 'FETCH_ADMINS_FAILURE'

export const TOGGLE_ADMIN_SUSPEND_REQUEST = 'TOGGLE_ADMIN_SUSPEND_REQUEST'
export const TOGGLE_ADMIN_SUSPEND_SUCCESS = 'TOGGLE_ADMIN_SUSPEND_SUCCESS'
export const TOGGLE_ADMIN_SUSPEND_FAILURE = 'TOGGLE_ADMIN_SUSPEND_FAILURE'
